export default "<div ng-class=\"::$ctrl.style.container\" ng-style=\"{ 'text-align': $ctrl.esAlign }\">\n  <ng-transclude></ng-transclude>\n</div>\n"